export default "__VITE_ASSET__C8byQDB4__"